export default __webpack_public_path__ + "static/media/map-illus.4a0a3b19.png";